
import React from "react";
import FileUpload from "./FileUpload";
import UploadItem from "./getItemId";
import UploadFolder from "./uploadFolder";
import SimilarIds from "./similarIds";
import CompleteTheLookPost from "./CompleteTheLookPost";

function UploadZone() {
  return (
    <div>
      <FileUpload />
      <UploadFolder />
      <UploadItem />
      <SimilarIds />
      <CompleteTheLookPost />
    </div>
  );
}

export default UploadZone;
